import API from "./api";
import secureLocalStorage from "react-secure-storage";

const user = JSON.parse(secureLocalStorage.getItem("profile"));
const branch = user ? user?.results?.branch : "";

export const fetchLocations = () => API.get("/api/v1/company-location");

// ! Assets

// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");

// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

// !claim routes

// category
export const createCategory = (postData) =>
  API.post(`/api/v1/eClaim-category`, postData);
export const getCategory = () => API.get(`/api/v1/eClaim-category`);
export const deleteCategory = (id) =>
  API.delete(`/api/v1/eClaim-category/${id}`);
export const updateCategory = (id, postData) =>
  API.patch(`/api/v1/eClaim-category/${id}`, postData);
// departments
export const createDepartment = (postData) =>
  API.post(`/api/v1/eClaim-department`, postData);

export const getDepartment = () => API.get(`/api/v1/eClaim-department`);
export const deleteDepartment = (id) =>
  API.delete(`/api/v1/eClaim-department/${id}`);
export const updateDepartment = (id, postData) =>
  API.patch(`/api/v1/eClaim-department/${id}`, postData);
// claims
export const createClaim = (postData) => API.post(`/api/v1/eClaim`, postData);

export const getClaim = () => API.get(`/api/v1/eClaim?branch=${branch}`);
export const deleteClaim = (id) => API.delete(`/api/v1/eClaim/${id}`);
export const getPendingClaim = () => API.get(`/api/v1/eClaim?status=pending`);
export const clearClaim = (id, postData) =>
  API.patch(`/api/v1/eClaim/${id}`, postData);
// user verification

export const sendVerificationCode = (postData) =>
  API.post("/api/v1/users/approval-verification-code", postData);
export const verifyCode = (code) =>
  API.get(`/api/v1/users/user-verification/${code}`);

// Company locations

export const locations = () => API.get("/api/v1/company-location");

// Approved Claims
export const getApprovedClaims = () => API.get(`/api/v1/eClaim`);

export const claimLimit = () => API.get("/api/v1/eClaim-limit");
export const updateClaimLimit = (id, postData) =>
  API.patch(`/api/v1/eClaim-limit/${id}`, postData);

export const approveBranchClaim = (id, postData) =>
  API.patch(`/api/v1/eClaim/${id}`, postData);
export const approveHeadOfficeClaim = (id, postData) =>
  API.patch(`/api/v1/eClaim/${id}`, postData);

// stats

export const branchStats = () =>
  API.get(`/api/v1/eClaim/branch-year-stats/${branch}`);
export const adminStats = () =>
  API.get(`/api/v1/eClaim/admin-year-stats/admin/previous-years`);

// unpaid claims

export const unpaidClaims = () =>
  API.get(
    `/api/v1/eClaim?payment_status[eq]=Not paid&status[eq]=approved&branch[eq]=${branch}`
  );

export const payclaim = (id, postData) =>
  API.patch(`/api/v1/eClaim/${id}`, postData);
